import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import * as storageServices from "../utils/services/storageServices";
import UserContext from "../utils/context/UserContext";

const PublicRoute = ({ component: Component, restricted, ...rest }) => {
  const { user } = useContext(UserContext);
  let isBoarded = user?.team?.isBoarded;
  let isAdmin = user?.members?.peerfiveAdmin;
  // user?.members?.raw_data?.is_admin ||
  // user?.members?.peerfiveAdmin ||
  // user?.members?.raw_data?.is_owner;

  return (
    <Route
      {...rest}
      render={(props) =>
        storageServices.get(storageServices.TOKEN) && restricted ? (
          !isBoarded && isAdmin ? (
            <Redirect to="/onboarding" />
          ) : (
            <Redirect to="/dashboard" />
          )
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

export default PublicRoute;
